const PageLoader = ({ label = "Loading" }) => {
  return (
    <div className="page-loader" id="page-loader" role="status" aria-live="polite">
      <div className="page-loader-box">
        <div className="page-loader-row">
          <div className="page-loader-dots" aria-hidden="true"></div>
        </div>
      </div>
      <span className="visually-hidden">{label}</span>
    </div>
  );
};

export default PageLoader;
